import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useDeleteEntity } from '../hooks/useDeleteEntity';

import { ConfirmDeleteModal } from './ConfirmDeleteModal';

export function RemoveEntityAction({
    entityId,
    entityName,
    deleteFn,
    queryKeys,
    successMessageKey,
    actionLabelKey = 'common.actions.remove',
    onRemoved,
}: {
    entityId: string;
    entityName: string;
    deleteFn: (id: string) => Promise<unknown>;
    queryKeys: string[];
    successMessageKey: string;
    actionLabelKey?: string;
    onRemoved?: () => void;
}) {
    const { t } = useTranslation();
    const { requestDelete, confirmDelete, closeConfirm, confirmOpen, isPending } = useDeleteEntity({
        deleteFn,
        queryKeys,
        successMessageKey,
        onDeleted: onRemoved,
    });

    return (
        <>
            <Button
                color="red"
                variant="light"
                onClick={() => requestDelete(entityId)}
                loading={isPending}
            >
                {t(actionLabelKey)}
            </Button>
            <ConfirmDeleteModal
                opened={confirmOpen}
                onClose={closeConfirm}
                onConfirm={confirmDelete}
                loading={isPending}
                entityName={entityName}
            />
        </>
    );
}
